import { AfterViewInit, Component, ElementRef, OnInit } from '@angular/core';
import { termsCatalog } from '../../../../data/terms-definition';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'glossary-of-terms-content',
  templateUrl: './glossary-of-terms-content.component.html',
  styleUrls: ['./glossary-of-terms-content.component.css'],
  standalone: false,
})
export class GlossaryOfTermsContentComponent implements OnInit, AfterViewInit {
  displayedColumns: string[] = ['term', 'explanation'];
  dataSource = termsCatalog.sort((a, b) => a.term.localeCompare(b.term));
  highlightedTermValue = '';

  constructor(
    private route: ActivatedRoute,
    private elementRef: ElementRef,
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.highlightedTermValue = params['term_value'] || null;
    });
  }

  ngAfterViewInit() {
    // Scroll to the selected term
    if (this.highlightedTermValue) {
      setTimeout(() => {
        const element = this.elementRef.nativeElement.querySelector(
          `#${this.highlightedTermValue}`,
        );
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, 0);
    }
  }
}
